import Cookies from 'js-cookie'

const set = (key, value, options, res) => (
  process.browser
    ? Cookies.set(key, value, options)
    : res?.cookie(key, value, options)
)

const remove = (key, options) => {
  if (process.browser) {
    Cookies.remove(key, options)
  }
}

const get = (key, req) => (
  process.browser
    ? getCookieFromBrowser(key)
    : getCookieFromServer(key, req)
)

const getCookieFromBrowser = Cookies.get

const getCookieFromServer = (key, req = {}) => {
  if (req?.headers && !req?.headers?.cookie) {
    return null
  }
  const rawCookie = req?.headers?.cookie
    .split(';')
    .find(c => c.trim().startsWith(`${key}=`))

  if (!rawCookie) {
    return null
  }

  return rawCookie.replace(`${key}=`, '').trim()
}

export default {
  set,
  remove,
  get,
}
